import InterBoldUrl from "assets/fonts/Inter-SemiBold.ttf?url";
import InterRegularUrl from "assets/fonts/Inter-Regular.ttf?url";
import jsPDF from "jspdf";

/**
 * jsPDF only ships the PDF core fonts, which is why the reports came out in
 * plain Helvetica while the app is set in Inter. The TTFs are embedded on
 * demand; if they cannot be read the document simply falls back to helvetica.
 */
export const REPORT_FONT = "Inter";

const FALLBACK_FONT = "helvetica";

const toBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);

  let binary = "";

  for (const byte of bytes) binary += String.fromCharCode(byte);

  return btoa(binary);
};

const loadFont = async (url: string) => {
  const response = await fetch(url);

  if (!response.ok) throw new Error(`Cannot read the report font: ${url}`);

  return toBase64(await response.arrayBuffer());
};

/** Returns the font family the report should be rendered with. */
export const registerReportFont = async (pdf: jsPDF): Promise<string> => {
  try {
    const [regular, bold] = await Promise.all([
      loadFont(InterRegularUrl),
      loadFont(InterBoldUrl)
    ]);

    pdf.addFileToVFS("Inter-Regular.ttf", regular);
    pdf.addFont("Inter-Regular.ttf", REPORT_FONT, "normal");

    pdf.addFileToVFS("Inter-SemiBold.ttf", bold);
    pdf.addFont("Inter-SemiBold.ttf", REPORT_FONT, "bold");

    pdf.setFont(REPORT_FONT, "normal");

    return REPORT_FONT;
  } catch {
    return FALLBACK_FONT;
  }
};
